import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { cleanupOrphanedRouteEvents, OrphanedRouteEventsCleanupResult } from './orphanedRouteEventsApi'

export const useCleanupOrphanedRouteEventsMutation = () => {
  return useMutation<OrphanedRouteEventsCleanupResult, AxiosError, void>({
    mutationFn: () => cleanupOrphanedRouteEvents(),
  })
}
